module.exports = __webpack_public_path__ + "img/bg_login.870c037e.png";